import { render } from "./PrimeVueUpload.vue?vue&type=template&id=07e724a1"
import script from "./PrimeVueUpload.vue?vue&type=script&lang=js"
export * from "./PrimeVueUpload.vue?vue&type=script&lang=js"

import "./PrimeVueUpload.vue?vue&type=style&index=0&id=07e724a1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__